import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as myGlobals from 'src/app/globals';
import { ShareResponseModel } from 'src/app/models/modal.model';
import { HttpResponseModel } from 'src/app/models/response.model';
import { UserAndGroup } from 'src/app/models/share-modal.model';
@Injectable()
export class ShareModalService {
  constructor(private http: HttpClient) {}

  sendShareList(requestBody: any): Observable<ShareResponseModel[]> {
    return this.http.post<ShareResponseModel[]>(`${myGlobals.Config.API}/shares`, requestBody);
  }

  getUserGroupLists(searchVal: string): Observable<HttpResponseModel<UserAndGroup[]>> {
    let params: HttpParams = new HttpParams();
    params = params.set('size', 1000).set('page', 0);

    const url = `${myGlobals.Config.API}/users/search/users-and-groups?query=` + searchVal;

    return this.http.get<HttpResponseModel<UserAndGroup[]>>(url, { params });
  }
}
